<div class="bg-primary-500 dark:bg-surface-950 p-6 lg:py-20 md:px-12 lg:px-20">
	<div class="flex flex-wrap justify-between items-center">
		<div class="w-full lg:w-6/12 lg:p-4 pr-8 lg:pr-12 max-w-2xl flex flex-col gap-12">
			<div class="gap-3 lg:gap-6 flex flex-col">
				<span class="text-primary-100 font-bold block uppercase leading-tight">{{ pageName() }}</span>
				@if (content.title.length > 0){
				<h1
					class="font-bold text-surface-0 dark:text-surface-0 text-5xl leading-tight max-w-xl"
					[innerHTML]="content.title"></h1>
				} @if (content.description.length > 0){
				<p
					class="mt-0 text-surface-0 dark:text-surface-400 leading-normal text-base md:text-lg"
					[innerHTML]="content.description"></p>
				} @if (content.link){
				<app-link
					[type]="content.link.type"
					[label]="content.link.title"
					[routerLink]="content.link.path"
					bgColor="dark"></app-link>
				}
			</div>
		</div>
		<div
			class="w-full lg:w-1/2 p-6 bg-primary-50 flex items-center justify-center dark:bg-primary-400/20 mt-6 lg:mt-0 h-full shadow-xl">
			<div class="relative w-full pb-[56.25%] h-0">
				@if (content.image){
				<img
					class="absolute top-0 left-0 object-cover"
					[ngSrc]="content.image.src"
					[alt]="content.image.alt"
					priority
					fill />
				}
			</div>
		</div>
	</div>
</div>
